import { Material } from '@core/model/Material.model';
import { ProdWarning } from './prodWarning.model';
import { DimensionModel } from '@core/model/dimension.model';
import { SeparadorInfo } from './separadorInfo.model';
import { LuzCapaInfo } from './LuzCapaInfo.model';
import { ModelInfo } from './modelInfo.model';
import { VilaxInfo } from './vilaxInfo.model';
import { GlassInfo } from './glassInfo.model';
import { ConfigService } from '@core/model/configService.model';
import { GlassService } from '@core/model/glassService.model';

export class DvhInfo extends ModelInfo {
    vAncho2: number;
    vAlto2: number;
    vDescuadrado: boolean;
    vListaConfig: DimensionModel[];
    vListaLuzCapa: LuzCapaInfo[];
    vListaSeparadores: SeparadorInfo[];
    vListaMateriales: Material[];
    vListaRestricciones: ProdWarning[];
    vConfiguracion: string;
    vValvula: boolean;
    vTemplado: boolean;
    vPulido: boolean;
    vCanteado: boolean;
    vFiloMatado: boolean;
    vArenado: boolean;
    vListaServicios: ConfigService[];
    GlassServices: GlassService[];
    vCornerTL: string;
    vCornerTR: string;
    vCornerBL: string;
    vCornerBR: string;
    vSideTop: string;
    vSideLeft: string;
    vSideRight: string;
    vSideBottom: string;
    vEspesor: number;

    constructor() {
    super();
    this.vModelo = 'DVH';
    this.vCodArticulo = '0603101';
    this.vCantidad = 1;
    this.vAlto2 = 0;
    this.vAncho2 = 0;
    this.vDescuadrado = false;
    this.vListaConfig = [];
    this.vListaLuzCapa = [];
    this.vListaSeparadores = [];
    this.vListaMateriales = [];
    this.vListaRestricciones = [];
    this.vConfiguracion = '';
    this.vValvula = false;
    this.vTemplado = false;
    this.vPulido = false;
    this.vCanteado = false;
    this.vFiloMatado = false;
    this.vArenado = false;
    this.vListaServicios = [];
    this.GlassServices = [];
    this.vCornerTL = '';
    this.vCornerTR = '';
    this.vCornerBL = '';
    this.vCornerBR = '';
    this.vSideTop = '';
    this.vSideLeft = '';
    this.vSideRight = '';
    this.vSideBottom = '';
    this.vEspesor = 0;
    }

    redimensionarModelo() {
        let vVilaxInfo: VilaxInfo;
        let vGlassInfo: GlassInfo;

        if (this.vListaLuzCapa.length > 0) {
            this.vListaLuzCapa.forEach(CapaTmp => {
                CapaTmp.vAncho1 = this.vAncho1;
                CapaTmp.vAlto1 = this.vAlto1;
                CapaTmp.vAncho2 = this.vAncho2;
                CapaTmp.vAlto2 = this.vAlto2;
                if (CapaTmp.vModelo !== undefined) {
                    if (CapaTmp.vModelo.vModelo === 'VILAX') {
                        let vModeloTmp = CapaTmp.vModelo as VilaxInfo;
                        vVilaxInfo = new VilaxInfo();
                        vVilaxInfo.vAncho1 = this.vAncho1;
                        vVilaxInfo.vAlto1 = this.vAlto1;
                        vVilaxInfo.vDescuadrado = this.vDescuadrado;
                        vVilaxInfo.vAncho2 = this.vAncho2;
                        vVilaxInfo.vAlto2 = this.vAlto2;
                        vModeloTmp.vAncho1 = this.vAncho1;
                        vModeloTmp.vAlto1 = this.vAlto1
                        vModeloTmp.vDescuadrado = this.vDescuadrado;
                        vModeloTmp.vAncho2 = this.vAncho2;
                        vModeloTmp.vAlto2 = this.vAlto2;
                        vVilaxInfo.vListaLuzCapa = vModeloTmp.vListaLuzCapa;
                        vVilaxInfo.redimensionarModelo();
                        vModeloTmp.vListaLuzCapa = vVilaxInfo.vListaLuzCapa;
                    } else if (CapaTmp.vModelo.vModelo === 'VIDRIO CORTADO') {
                        let vModeloTmp = CapaTmp.vModelo as GlassInfo;
                        vGlassInfo = new GlassInfo();
                        vGlassInfo.vAncho1 = this.vAncho1;
                        vGlassInfo.vAlto1 = this.vAlto1;
                        vGlassInfo.vDescuadrado = this.vDescuadrado;
                        vGlassInfo.vAncho2 = this.vAncho2;
                        vGlassInfo.vAlto2 = this.vAlto2;
                        vModeloTmp.vAncho1 = this.vAncho1;
                        vModeloTmp.vAlto1 = this.vAlto1;
                        vModeloTmp.vDescuadrado = this.vDescuadrado;
                        vModeloTmp.vAncho2 = this.vAncho2;
                        vModeloTmp.vAlto2 = this.vAlto2;
                        vGlassInfo.vListaServicios = vModeloTmp.vListaServicios;
                        vGlassInfo.redimensionarModelo();
                        vModeloTmp.vListaServicios = vGlassInfo.vListaServicios;
                    }
                }
            });
        }
    }
}
